import { prefixObjectValues } from '../utils';

const form = {
  form: 'form',
  specialtyNameField: 'specialty-name-field',
  privilegeCategoryField: 'privilege-category-field',
  privilegeTypeField: 'privilege-type-field',
  privilegeNameField: 'privilege-name-field',
  assignmentDateField: 'assignment-date-field',
  privilegeNotesInput: 'privilege-notes-input',
  removeBtn: 'remove-btn',
  submitBtn: 'submit-btn',
  cancelBtn: 'cancel-btn',
};

export default prefixObjectValues(form, 'privileges-form');
